import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _23039728 = () => interopDefault(import('../../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _0d62f55c = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _1ba7c6dc = () => interopDefault(import('../../../pages/style-guide.vue' /* webpackChunkName: "pages/style-guide" */))
const _039cf4c1 = () => interopDefault(import('../../../pages/trace.vue' /* webpackChunkName: "pages/trace" */))
const _44752684 = () => interopDefault(import('../../../pages/trace/index.vue' /* webpackChunkName: "pages/trace/index" */))
const _58976cc9 = () => interopDefault(import('../../../pages/account/activate.vue' /* webpackChunkName: "pages/account/activate" */))
const _8fb450fa = () => interopDefault(import('../../../pages/account/login.vue' /* webpackChunkName: "pages/account/login" */))
const _ccb3bd40 = () => interopDefault(import('../../../pages/account/logout.vue' /* webpackChunkName: "pages/account/logout" */))
const _3a036e79 = () => interopDefault(import('../../../pages/account/register.vue' /* webpackChunkName: "pages/account/register" */))
const _d17ebb2e = () => interopDefault(import('../../../pages/account/reset.vue' /* webpackChunkName: "pages/account/reset" */))
const _626ed8be = () => interopDefault(import('../../../pages/_tower.vue' /* webpackChunkName: "pages/_tower" */))
const _3af2f95d = () => interopDefault(import('../../../pages/print/recipes/_recipe.vue' /* webpackChunkName: "pages/print/recipes/_recipe" */))
const _1cfca2c5 = () => interopDefault(import('../../../pages/articles/_article.vue' /* webpackChunkName: "pages/articles/_article" */))
const _72a8523f = () => interopDefault(import('../../../pages/collections/_collection.vue' /* webpackChunkName: "pages/collections/_collection" */))
const _ac014282 = () => interopDefault(import('../../../pages/recipes/_recipe.vue' /* webpackChunkName: "pages/recipes/_recipe" */))
const _34240f8e = () => interopDefault(import('../../../pages/products/_product/_variant.vue' /* webpackChunkName: "pages/products/_product/_variant" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _23039728,
    name: "account"
  }, {
    path: "/search",
    component: _0d62f55c,
    name: "search"
  }, {
    path: "/style-guide",
    component: _1ba7c6dc,
    name: "style-guide"
  }, {
    path: "/trace",
    component: _039cf4c1,
    children: [{
      path: "",
      component: _44752684,
      name: "trace"
    }]
  }, {
    path: "/account/activate/:customerId/:token",
    component: _58976cc9,
    name: "account-activate"
  }, {
    path: "/account/login",
    component: _8fb450fa,
    name: "account-login"
  }, {
    path: "/account/logout",
    component: _ccb3bd40,
    name: "account-logout"
  }, {
    path: "/account/register",
    component: _3a036e79,
    name: "account-register"
  }, {
    path: "/account/reset/:customerId/:token",
    component: _d17ebb2e,
    name: "account-reset"
  }, {
    path: "/articles/hacks",
    component: _626ed8be,
    name: "category-page-articles-listing-hacks"
  }, {
    path: "/articles/harvest",
    component: _626ed8be,
    name: "category-page-articles-listing-harvest"
  }, {
    path: "/articles/health",
    component: _626ed8be,
    name: "category-page-articles-listing-health"
  }, {
    path: "/recipes/appetizers",
    component: _626ed8be,
    name: "category-page-recipe-listing-appetizers"
  }, {
    path: "/recipes/beverages",
    component: _626ed8be,
    name: "category-page-recipe-listing-beverages"
  }, {
    path: "/recipes/breads",
    component: _626ed8be,
    name: "category-page-recipe-listing-breads"
  }, {
    path: "/recipes/desserts",
    component: _626ed8be,
    name: "category-page-recipe-listing-desserts"
  }, {
    path: "/recipes/main-dishes",
    component: _626ed8be,
    name: "category-page-recipe-listing-main-dishes"
  }, {
    path: "/recipes/salad-dressings",
    component: _626ed8be,
    name: "category-page-recipe-listing-salad-dressings"
  }, {
    path: "/recipes/sauces-spreads",
    component: _626ed8be,
    name: "category-page-recipe-listing-sauces-spreads"
  }, {
    path: "/recipes/soups",
    component: _626ed8be,
    name: "category-page-recipe-listing-soups"
  }, {
    path: "/recipes/vegetables-sides",
    component: _626ed8be,
    name: "category-page-recipe-listing-vegetables-sides"
  }, {
    path: "/print/recipes/:recipe?",
    component: _3af2f95d,
    name: "print-recipes-recipe"
  }, {
    path: "/articles/:article",
    component: _1cfca2c5,
    name: "articles-article"
  }, {
    path: "/collections/:collection?",
    component: _72a8523f,
    name: "collections-collection"
  }, {
    path: "/recipes/:recipe",
    component: _ac014282,
    name: "recipes-recipe"
  }, {
    path: "/products/:product?/:variant?",
    component: _34240f8e,
    name: "products-product-variant"
  }, {
    path: "/:tower*",
    component: _626ed8be,
    name: "tower"
  }],

  parseQuery: (queryString) => {
    return require('qs').parse(queryString);
  },
  stringifyQuery: (object) => {
    const queryString = require('qs').stringify(object);
    return queryString ? '?' + queryString : '';
  },
  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
